import NoMatch from './NoMatch';
import './NoMatch.scss';

export default NoMatch;
